import type { PrismicDocument, Query, Repository } from "@prismicio/client"

import { GetAllByEveryTagRequest } from "./GetAllByEveryTagRequest"
import { GetAllByIDsRequest } from "./GetAllByIDsRequest"
import { GetAllBySomeTagsRequest } from "./GetAllBySomeTagsRequest"
import { GetAllByTagRequest } from "./GetAllByTagRequest"
import { GetAllByTypeRequest } from "./GetAllByTypeRequest"
import { GetAllByUIDsRequest } from "./GetAllByUIDsRequest"
import { GetByEveryTagRequest } from "./GetByEveryTagRequest"
import { GetByIDRequest } from "./GetByIDRequest"
import { GetByIDsRequest } from "./GetByIDsRequest"
import { GetBySomeTagsRequest } from "./GetBySomeTagsRequest"
import { GetByTagRequest } from "./GetByTagRequest"
import { GetByTypeRequest } from "./GetByTypeRequest"
import { GetByUIDRequest } from "./GetByUIDRequest"
import { GetByUIDsRequest } from "./GetByUIDsRequest"
import { GetFirstRequest } from "./GetFirstRequest"
import { GetRepositoryRequest } from "./GetRepositoryRequest"
import { GetRequest } from "./GetRequest"
import { GetSingleRequest } from "./GetSingleRequest"
import { GetTagsRequest } from "./GetTagsRequest"

/**
 * All available requests for the API explorer.
 */
export const Requests = {
  [GetRequest.type]: GetRequest,
  [GetFirstRequest.type]: GetFirstRequest,

  [GetByIDRequest.type]: GetByIDRequest,
  [GetByIDsRequest.type]: GetByIDsRequest,
  [GetAllByIDsRequest.type]: GetAllByIDsRequest,

  [GetByUIDRequest.type]: GetByUIDRequest,
  [GetByUIDsRequest.type]: GetByUIDsRequest,
  [GetAllByUIDsRequest.type]: GetAllByUIDsRequest,

  [GetSingleRequest.type]: GetSingleRequest,
  [GetByTypeRequest.type]: GetByTypeRequest,
  [GetAllByTypeRequest.type]: GetAllByTypeRequest,

  [GetByTagRequest.type]: GetByTagRequest,
  [GetAllByTagRequest.type]: GetAllByTagRequest,

  [GetByEveryTagRequest.type]: GetByEveryTagRequest,
  [GetAllByEveryTagRequest.type]: GetAllByEveryTagRequest,

  [GetBySomeTagsRequest.type]: GetBySomeTagsRequest,
  [GetAllBySomeTagsRequest.type]: GetAllBySomeTagsRequest,

  [GetRepositoryRequest.type]: GetRepositoryRequest,
  [GetTagsRequest.type]: GetTagsRequest,
} as const

export type Requests = typeof Requests

export type RequestType = keyof Requests

// We use the tuple/spread syntax to accommodate zod's enum type's expectations.
export const RequestTypes = Object.keys(Requests) as [
  RequestType,
  ...RequestType[],
]

export type RequestRunReturnType =
  | PrismicDocument[]
  | PrismicDocument
  | Query
  | Repository
  | string[] // `getTags()` response type
